export default "__VITE_ASSET__DUZIZCcP__"